import React, { useState, useEffect } from "react";
import About from "./About";
import AboutList from "./AboutList";
const LOCAL_STORAGE_KEY = "about";

const EditAbout = () => {
  const [entries, setEntries] = useState([]);
  const [mode, setMode] = useState("list"); // 'list' or 'form'
  const [editingIndex, setEditingIndex] = useState(null);

  useEffect(() => {
      const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (stored) {
        setEntries(JSON.parse(stored));
      }
    }, []);
    useEffect(() => {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(entries));
      }, [entries]);
    
  const handleSubmit = (data) => {
     setEntries((prev) => {
      const exists = prev.find((n) => n.index === data.index);
      if (exists) {
        return prev.map((n) => (n.index === data.index ? data : n));
      } else {
        return [...prev, data];
      }
    });
    
    setMode("list");
    setEditingIndex(null);
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setMode("form");
  };

  const handleDelete = (index) => {
    const updated = [...entries];
    updated.splice(index, 1);
    setEntries(updated);
  };

  const handleCreate = () => {
    setEditingIndex(null);
    setMode("form");
  };

  return (
    <div className="container mt-4">
      {mode === "list" ? (
        <AboutList
          entries={entries}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onCreate={handleCreate}
        />
      ) : (
        <About
          onSubmit={handleSubmit}
          editingData={editingIndex !== null ? entries[editingIndex] : null}
          onCancel={() => setMode("list")}
        />
      )}
    </div>
  );
};

export default EditAbout;
